export default __webpack_public_path__ + "static/media/filtros.52eb404a.svg";